import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import { WEBPAGE_META } from "./meta";
import BounceCardSection from "@/features/anime/BounceCardSection";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Link } from "react-router-dom";
import PurchaseInstructions from "@/core/components/shop/PurchaseInstructions";
gsap.registerPlugin(ScrollTrigger);
const HomePage = () => {
    const headerRef = useRef(null);
    const paragraphRef = useRef(null);
    const buttonRef = useRef(null);
    useEffect(() => {
        console.log("HomePage mounted");
        gsap.fromTo(headerRef.current, { opacity: 0, y: -50 }, {
            opacity: 1,
            y: 0,
            duration: 1,
            scrollTrigger: {
                trigger: headerRef.current,
                start: "top 80%",
            },
        });
        gsap.fromTo(paragraphRef.current, { opacity: 0, y: 50 }, {
            opacity: 1,
            y: 0,
            duration: 1,
            scrollTrigger: {
                trigger: paragraphRef.current,
                start: "top 80%",
            },
        });
        gsap.fromTo(buttonRef.current, { opacity: 0, y: 50 }, {
            opacity: 1,
            y: 0,
            duration: 1,
            scrollTrigger: {
                trigger: buttonRef.current,
                start: "top 80%",
            },
        });
    }, []);
    return (_jsxs("div", { children: [_jsxs(Helmet, { children: [_jsx("title", { children: WEBPAGE_META.title }), _jsx("meta", { name: "description", content: WEBPAGE_META.meta_description }), _jsx("meta", { property: "og:image", content: WEBPAGE_META.image })] }), _jsxs("section", { className: "relative bg-primary-gradient-br h-[21rem] md:h-screen bg-cover bg-center", style: {
                    backgroundImage: "url('/images/gallery/andrew-sample-food-photography-parallax-4.jpg')",
                }, children: [_jsx("div", { className: "absolute inset-0 bg-black bg-opacity-50" }), _jsx("div", { className: "absolute inset-0 flex items-center justify-center", children: _jsxs("div", { className: "flex flex-col items-center w-11/12 mx-auto text-center text-white", children: [_jsx("h1", { ref: headerRef, className: "text-4xl font-bold md:text-6xl header-font", children: "Northern Virginia Foodies" }), _jsx("p", { ref: paragraphRef, className: "mt-4 text-lg font-medium lato-light", children: "Welcome to the Foodies Community" }), _jsx(Link, { to: "/products", ref: buttonRef, children: _jsxs("button", { className: "px-4 py-2 mt-6 tracking-wide text-white lato-bold bg-[#203a43] rounded-full hover:bg-white hover:text-[#203a43]", children: ["Shop Online", _jsx("span", { className: "ml-1", children: "\uD83D\uDECD\uFE0F" })] }) })] }) })] }), _jsx("section", { className: " bg-gradient-green", children: _jsxs("div", { className: "w-11/12 max-w-4xl pt-10 mx-auto text-center", children: [_jsx("h1", { className: "text-4xl font-bold text-white mb-9 poiret-one", children: "Welcome to Northern Virginia Foodies" }), _jsx(BounceCardSection, {}), _jsx(PurchaseInstructions, {})] }) })] }));
};
export default HomePage;
